import { Component } from '@angular/core';
import { filter } from 'rxjs';
import { AuthenticatedUserService } from './core/services/authenticated-user/authenticated-user.service';
import { TranslationService } from './core/services/translation/translation.service';
import { getTranslocoLang } from './utils/translocoLang';
import { getBrowserLang } from '@ngneat/transloco';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
/**
   TODO: JSDoc
 **/
export class AppComponent {
  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly swUpdate: SwUpdate
  ) {
    this.swUpdate.versionUpdates.subscribe((update) => {
      if (update.type === 'VERSION_READY') {
        location.reload();
      }
    });
    const browserLang = getBrowserLang();
    const previousLang = localStorage.getItem('translocoLang');
    if ((browserLang === 'pt' || browserLang === 'es') && !previousLang) {
      this.translationService.setActiveLang(getTranslocoLang(browserLang));
    }

    this.authenticatedUserService.initializeRepresentative();
    this.authenticatedUserService.representative$
      .pipe(filter((representative) => representative !== undefined))
      .subscribe((representative) => {
        const lang = representative!.language;
        if (lang) {
          this.translationService.setActiveLang(getTranslocoLang(lang));
          this.authenticatedUserService.resetBannerData();
          this.authenticatedUserService.initializeBanner();
        }
      });
  }
}
